function getParamsFromUrl(value: any): any {
	if (value === "false" || value === "off") {
		return false;
	}

	if (value === "true" || value === "on") {
		return true;
	}

	if (value && typeof value === "string" && value.match(/^-?[0-9][0-9+]*$/)) {
		const cleanedValue = Number(value.replace(/\+/g, ""));

		if (!isNaN(cleanedValue)) {
			return cleanedValue;
		}
	}

	return value;
}

export const getUrlParameters = (url?: string): Record<string, any> => {
	const newUrl = url || window.location.search.substring(1);
	const request: Record<string, any> = {};
	const pairs = newUrl.substring(newUrl.indexOf("?") + 1).split("&");
	pairs.forEach((item) => {
		const pair = item.split("=");

		if (pair.length === 2) {
			let name = decodeURIComponent(pair[0]);
			const value = getParamsFromUrl(decodeURIComponent(pair[1]));

			if (name.endsWith("[]")) {
				name = name.substr(0, name.length - 2);

				if (Array.isArray(request[name])) {
					request[name].push(value);
				} else {
					request[name] = [value];
				}
			} else if (request[name] === undefined) {
				request[name] = value;
			} else if (Array.isArray(request[name])) {
				request[name].push(value);
			} else {
				request[name] = [request[name], value];
			}
		}
	});

	return request;
};

/**
 * Aktuális URL egy paraméterének lekérdezése
 *
 * @param name Paraméter neve
 * @param def  Alapértelmezett érték
 *
 * @return Paraméter értéke, vagy ha nincs akkor a default érték.
 */
export const getUrlParameter = (name: string, def?: string): string => {
	const value = getUrlParameters()[name];

	if (value === undefined) {
		return def;
	}

	return value;
};

/**
 * Marketing URL paraméterek kitöltése
 *
 * @param url Mérő url
 *
 * @return Kitöltött mérő url
 */
export const urlPreProcess = (url: string): string => {
	const urlEncoded = encodeURIComponent(window?.location?.href);

	return (url ?? "")
		.replace("http://", "https://")
		.replace("[timestamp]", new Date().valueOf().toString())
		.replace("[LOCATION]", urlEncoded)
		.replace("[location]", urlEncoded);
};

const paramToUrlParam = (name: string, value: any): string => {
	if (Array.isArray(value)) {
		return value
			.filter((item) => item !== undefined && typeof item !== "object")
			.map((subValue) => `${encodeURIComponent(name)}[]=${encodeURIComponent(subValue)}`)
			.join("&");
	}

	return `${encodeURIComponent(name)}=${encodeURIComponent(value)}`;
};

export const generateUrlParams = (params: Record<string, any>): string => {
	if (typeof params !== "object") {
		return undefined;
	}

	return Object.keys(params)
		.map((name) => ({ name, value: params[name] }))
		.filter(
			(param) =>
				(Array.isArray(param.value) && param.value.length !== 0) ||
				(typeof param.value !== "object" && param.value !== undefined),
		)
		.map((param) => paramToUrlParam(param.name, param.value))
		.join("&");
};

export const addParameterToURL = (url: string, params: Record<string, any>): string => {
	if (typeof params !== "object") {
		return url;
	}

	const oldParams = getUrlParameters(url);
	const cleanedUrl = url.split("?")[0];
	const query = generateUrlParams({ ...oldParams, ...params });

	if (query.length === 0) {
		return cleanedUrl;
	}

	return `${cleanedUrl}?${query}`;
};

export function joinLiterals(list: string[] | string = []): string {
	if (!list || list?.length === 0) {
		return undefined;
	}

	if (typeof list === "string") {
		return list;
	}

	return list.join(",");
}

export const buildUrl = (base: string, path = "/", params: Record<string, any> = {}): string => {
	const url = `${base}/${path.replace(/^\//, "")}`;

	return addParameterToURL(url, params);
};
